import type { Theme } from "@mui/material/styles";

/** Create Project / Create Thread modal — spacing (rem @ 16px root). */
export const MODAL_FORM_LAYOUT = {
  fieldStackGap: "1.25rem",
  gapFieldSectionToActions: "2rem",
  actionsPaddingBottom: "2rem",
  multilineInputPadding: "12px 16px",
} as const;

export function modalFormFieldLabelSx(theme: Theme) {
  return {
    fontWeight: 500,
    color: theme.palette.custom.gray[700],
    fontSize: "0.875rem",
    mb: "0.375rem",
    display: "block",
  } as const;
}

export function modalFormOutlinedInputRootSx(theme: Theme) {
  return {
    borderRadius: "0.5rem",
    fontSize: "0.875rem",
    backgroundColor: theme.palette.custom.backgroundPaper,
    "& fieldset": { borderColor: theme.palette.custom.gray[300] },
    "&:hover fieldset": { borderColor: theme.palette.custom.gray[400] },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.custom.primary,
      borderWidth: 1,
    },
  };
}

export function modalFormTextFieldSx(theme: Theme) {
  return {
    "& .MuiOutlinedInput-root": modalFormOutlinedInputRootSx(theme),
  };
}

/** Multiline fields only — padding top/right/bottom/left = 12 / 16 / 12 / 16 px. */
export function modalFormMultilineTextFieldSx(theme: Theme) {
  return {
    ...modalFormTextFieldSx(theme),
    "& .MuiOutlinedInput-input": {
      padding: MODAL_FORM_LAYOUT.multilineInputPadding,
    },
  };
}

export function modalFormSelectSx(theme: Theme) {
  return {
    borderRadius: "0.5rem",
    fontSize: "0.875rem",
    bgcolor: theme.palette.custom.backgroundPaper,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.custom.gray[300],
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.custom.gray[400],
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.custom.primary,
      borderWidth: 1,
    },
  };
}

export const modalFormIntroBodySx = (theme: Theme) => ({
  color: theme.palette.custom.gray[700],
  fontSize: "1rem",
  lineHeight: 1.5,
});
